import { Components, Theme } from '@mui/material/styles';
import { palette } from 'theme/palette';
import {
  scrollbarHorizontalSX,
  scrollBarsSX,
  scrollbarVerticalSX,
} from 'theme/utility/utility.styles';
import { muiDataGridRowStyleOverride } from './MuiDataGrid/MuiDataGridRowStyleOverride';
import { muiDataGridHeadersStyleOverride } from './MuiDataGrid/MuiDataGridHeadersStyleOverride';

export const MuiDataGrid: Components<Theme>['MuiDataGrid'] = {
  defaultProps: {
    disableRowSelectionOnClick: true,
  },
  styleOverrides: {
    root: ({ ownerState, theme }) => {
      const loading = ownerState?.loading ?? false;
      return {
        borderRadius: 0,
        border: 'none',
        backgroundColor: `${theme.palette.DataGrid.bg} !important`,
        '& .MuiDataGrid-filler--pinnedRight': {
          borderLeft: 'none',
        },

        '& .MuiDataGrid-filler--pinnedLeft': {
          borderRight: 'none',
        },

        '& .header-sticky': {
          maxWidth: `${theme.spacing(50)} !important`,
          minWidth: `${theme.spacing(50)} !important`,
          padding: theme.spacing(0, 5),
        },

        '& .MuiDataGrid-overlayWrapper': {
          width: '100%',
          height: '100%',
        },
        '& .MuiDataGrid-columnSeparator': {
          opacity: 0,
          '&:hover': {
            opacity: 1,
            color: palette.grey[400],
          },
        },
        '& .MuiDataGrid-columnHeaders': muiDataGridHeadersStyleOverride({ loading, theme }),

        '& .MuiDataGrid-row': muiDataGridRowStyleOverride,

        '& .MuiDataGrid-columnHeaderTitleContainerContent': {
          width: '100%',
        },

        '& .MuiDataGrid-scrollbar--vertical::-webkit-scrollbar': {
          width: theme.spacing(14),
        },

        '& .MuiDataGrid-scrollbar--horizontal': {
          ...scrollbarHorizontalSX,
          ...scrollBarsSX,
        },

        '& .MuiDataGrid-scrollbar--vertical': {
          ...scrollbarVerticalSX,
          ...scrollBarsSX,
        },
        '& .MuiDataGrid-skeletonHeaderRow': {
          backgroundColor: palette.grey[100],
        },
        '& .MuiDataGrid-skeletonBodyRow': {
          backgroundColor: palette.background.paper,
        },
        '& .MuiDataGrid-detailPanel': {
          width: 'auto',
        },

        '& .MuiDataGrid-columnHeaderDraggableContainer': {
          cursor: 'default !important',
        },
      };
    },
    footerContainer: ({ theme }) => ({
      minHeight: theme.spacing(52),
      '& .MuiTablePagination-root': {
        flex: 1,
        minHeight: theme.spacing(53),

        '& .MuiTablePagination-select': {
          minWidth: 'min-content',
        },
      },
    }),
    cellCheckbox: ({ theme }) => ({
      '& .MuiCheckbox-colorPrimary': {
        color: theme.palette.text.secondary,
      },
    }),
    columnHeaderCheckbox: ({ theme }) => ({
      '& .MuiCheckbox-colorPrimary': {
        color: theme.palette.text.secondary,
      },
    }),
  },
};
